@if(selectedScenariosSignal().length <= 0){
  <div class="text-center">
    <div><tds-icon name="show_chart"></tds-icon></div>
    <div>Select at least one scenario to display prices data</div>
  </div>
}

<div class="chart-flex-container">
  <div class="chart-container">
    <canvas id="PricesChart">{{ chart }}</canvas>
  </div>
  <div id="legend-container"></div>
</div>
